import { Component, inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CloseOverlayKeyboardDirective, CloseOverlayClickDirective } from '../../directives/close-overlay.directives';
import { IconDirective } from '../../directives/icon.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lv-pdf-dialog',
  styleUrls: ['pdf-dialog.component.scss'],
  templateUrl: 'pdf-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [CloseOverlayKeyboardDirective, CloseOverlayClickDirective, IconDirective, TranslateModule]
})
export class PDFDialogComponent implements OnInit {
  private sanitizer = inject(DomSanitizer);

  @Input() title: string;
  @Input() url: string;

  safeURL: SafeResourceUrl;

  ngOnInit() {
    this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://docs.google.com/viewer?url=${this.url}&embedded=true`
    );
  }
}
